import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

const LayananUtama = () => {
    const layananUtama = useSelector(state => state.data.layananUtama);

    return (
        <section className="py-16 bg-[#F8FAFC]">
            <div className="container mx-auto px-4">
                <h2 className="section-title">Layanan Utama</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                    {layananUtama.map((layanan) => (
                        <Link
                            key={layanan.id}
                            to={layanan.link}
                            className="card-glass text-center hover:transform hover:scale-105 transition-all duration-300"
                        >
                            <div className="text-5xl mb-4">{layanan.icon}</div>
                            <h3 className="text-xl font-bold text-[#1E3A8A] mb-2">{layanan.title}</h3>
                            <p className="text-gray-600">{layanan.description}</p>
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default LayananUtama;